import { useIsLeftNavForcedCollapsedAtCurrentWidth } from '@ms/yammer-web-core-ui/dist/components/AppLayout';

import { useIsLeftNavCollapseDisabled } from './leftNavCollapseDisabledContext';
import { useIsLeftNavCollapsed } from './leftNavCollapseStore';
import { useIsLeftNavCollapseEnabled } from './useIsLeftNavCollapseEnabled';

export const useIsLeftNavCollapsedActive = (): boolean => {
  const isLeftNavCollapseEnabled = useIsLeftNavCollapseEnabled();
  const isLeftNavCollapsed = useIsLeftNavCollapsed();
  const isForcedCollapsed = useIsLeftNavForcedCollapsedAtCurrentWidth();
  const isCollapseDisabled = useIsLeftNavCollapseDisabled();

  if (isCollapseDisabled) {
    return false;
  }

  return isLeftNavCollapseEnabled && (isLeftNavCollapsed || isForcedCollapsed);
};
